import React, { Component } from 'react';
import axios from "axios";
import ApiURL from "../../api/ApiURL";
import cogoToast from "cogo-toast";
import ManageBooking from '../../components/transaction/Booking/ManageBooking';
import Topbar from '../../components/common/Topbar';
import Footer from '../../components/common/Footer';

class ManageBookingPage extends Component {
    constructor({ match }) {
        super();
        this.state = {
            bookingId: match.params.bkId,

        }
    }
    
    componentDidMount() {
        window.scroll(0, 0);
    }

    render() {
        return (
            <>
                <div id="content-wrapper" className="d-flex flex-column">
                    <div id="content">

                        <Topbar />

                        <div className="container-fluid">

                            {/* <PageTitle Title="Manage Search Lead" /> */}
                            {/* {
                                this.state.bookingData != null &&
                                <ManageBooking bookingData={this.state.bookingData} />
                            } */}

                            <ManageBooking bookingId={this.state.bookingId} />


                        </div>

                    </div>

                    <Footer />

                </div>
            </>
        );
    }
}

export default ManageBookingPage;